export const trackError = (field: string, message: string | object, ...rest: any[]) => {

    const formattedMessage =
        typeof message === "string" ? message : JSON.stringify(message);
    logEvent({
        options: {
            eventAction: "error",
            eventProperties: {
                field,
                message: formattedMessage,
                ...(rest && rest.length > 0 && { additionalData: rest }),
            },
            eventInteraction: true,
            eventLabel: `Validation error in ${field}`,
            eventName: "error_messages",
        },
    });
};

export const trackShare = (method:string,content_type:string,item_id:string)=>{
    logEvent({
        options: {
            eventAction: "click",
            ecommerce:{
                method:method,
                content_type:content_type,
                item_id:item_id
            },
            eventProperties: {},
            eventInteraction: true,
            eventLabel: `share via ${method}`,
            eventName: "share",
        },
    });
}